import { createFileRoute } from '@tanstack/react-router';
import PalmaPage from '@/pages/static/PalmaPage';

export const Route = createFileRoute('/palma/')({
  component: PalmaPage,
});
